export default "__VITE_ASSET__e8f65efb__"